import { PartnerHostnamesApiResponse } from '../types';

export const fetchPartnerHostNames = async (): Promise<PartnerHostnamesApiResponse> => {
  return fetch('/delegate/partnerinfo/list')
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      } else {
        return undefined;
      }
    })
    .then((response) => {
      return response.data;
    });
};
